'use client';

import { cva, VariantProps } from 'class-variance-authority';
import { ComponentProps, ForwardedRef, forwardRef } from 'react';

const styles = cva([], {
  variants: {
    type: {
      text: [
        'bg-background-input',
        'border',
        'border-background-border',
        'text-text-input',
        'sm:text-sm',
        'rounded-lg',
        'block',
        'w-full',
        'p-2.5',
      ],
      email: [
        'bg-background-input',
        'border',
        'border-background-border',
        'text-text-input',
        'sm:text-sm',
        'rounded-lg',
        'block',
        'w-full',
        'p-2.5',
      ],
      password: [
        'bg-background-input',
        'border',
        'border-background-border',
        'text-text-input',
        'sm:text-sm',
        'rounded-lg',
        'block',
        'w-full',
        'p-2.5',
      ],
      tel: [
        'bg-background-input',
        'border',
        'border-background-border',
        'text-text-input',
        'sm:text-sm',
        'rounded-lg',
        'block',
        'w-full',
        'p-2.5',
      ],
      radio: [
        'inline-block',
        'h-8',
        'w-8',
        'cursor-pointer',
        'appearance-none',
        'rounded-full',
        'border-2',
        'text-center',
      ],
      search: [
        'block',
        'w-full',
        'rounded-lg',
        'border',
        'border-gray-300',
        'bg-background-input',
        'p-4',
        'ps-10',
        'text-text-input',
        'ring-0',
      ],
    },
    focus: {
      branded: [
        'focus:ring-text-highlight',
        'focus:border-text-highlight',
        'focus:ring-0',
        'focus:outline-none',
      ],
      browser: [''],
    },
  },
  defaultVariants: {
    type: 'text',
    focus: 'branded',
  },
});

type InputProps = ComponentProps<'input'> & VariantProps<typeof styles>;

export const Input = forwardRef(function Input(
  { type, ...props }: InputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <input
      className={styles({ type })}
      type={type}
      ref={ref}
      {...props}
      data-testid={`input: ${props.name}`}
    />
  );
});
